import { DataSource, Layout, Table } from "@mcleod/components";

export abstract class AutogenLayoutDrsPendingDeductList extends Layout {
    sourceDrsPendingDeduct: DataSource;
    tableDrsPendingDeduct: Table;
}
